<template>
  <div class="main-container">
    <div class="chart-container">
      <div class="chart-box">
        <h4>سود ناخالص (همت)</h4>
        <BarChart :data="grossProfitData"/>
      </div>
      <div class="chart-box">
        <h4>سود قبل از کسر مالیات (همت)</h4>
        <BarChart :data="profitBeforeTaxData"/>
      </div>
    </div>

    <div class="chart-container">
      <div class="chart-box w-full">
        <h4>حاشیه سود ناخالص و حاشیه سود قبل از کسر مالیات شش ماهه سال 1403</h4>
        <LineChart :data="profitMarginData" style="max-height: 90%"/>
      </div>
    </div>
  </div>
</template>

<script>
import LineChart from '@/components/PerformanceManagement/EconomicOperationReport/LineChart.vue'
import DataTable from '@/components/PerformanceManagement/EconomicOperationReport/DataTable.vue'
import BarChart from "@/components/PerformanceManagement/EconomicOperationReport/BarChart.vue";

export default {
  components: {
    BarChart,
    LineChart,
    DataTable
  },
  data() {
    return {
      grossProfitData: {
        labels: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور'],
        datasets: [
          {
            label: 'تجمعی ۱۴۰۲',
            backgroundColor: '#007bff',
            data: [2.3, 9.3, 14.2, 16.5, 18.5, 27.9]
          },
          {
            label: 'بودجه تجمعی ۱۴۰۳',
            backgroundColor: '#28a745',
            data: [3.6, 10.5, 16.3, 19.8, 22.9, 40.1]
          },
          {
            label: 'تجمعی ۱۴۰۳',
            backgroundColor: '#be3434',
            data: [1.9, 9.6, 15.1, 16.5, 18.2, 26.9]
          }
        ]
      },

      profitBeforeTaxData: {
        labels: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور'],
        datasets: [
          {
            label: 'تجمعی ۱۴۰۲',
            backgroundColor: '#007bff',
            data: [54, 107, 168, 185, 195, 257]
          },
          {
            label: 'بودجه تجمعی ۱۴۰۳',
            backgroundColor: '#28a745',
            data: [34, 67, 67, 77, 87, 191]
          },
          {
            label: 'تجمعی ۱۴۰۳',
            backgroundColor: '#be3434',
            data: [44, 97, 162, 175, 179, 189]
          }
        ]
      },

      profitMarginData: {
        labels: ['فولاد', 'سیمان', 'کاشی و سرامیک'],
        datasets: [
          {
            label: 'حاشیه سود قبل از کسر مالیات (میانگین هلدینگ 18%)',
            backgroundColor: '#ffc107',
            data: [13, 38, 25]
          },
          {
            label: 'حاشیه سود ناخالص (میانگین هلدینگ 12%)',
            backgroundColor: '#17a2b8',
            data: [7, 32, 17]
          }
        ]
      },
    }
  }
}
</script>

<style scoped>
.main-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  direction: rtl;
  padding: 1.5vw;
  background-color: #f0f2f5;
  box-sizing: border-box;
  position: relative;
}

.chart-container {
  display: flex;
  justify-content: space-between;
  width: 100%;
  max-height: 18vw;
  margin-bottom: 1.5vw;
}

.chart-box {
  width: 48%;
  background-color: white;
  padding: 1vw;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}

.chart-box h4 {
  font-size: .9vw !important;
  margin-bottom: .6vw;
  text-align: center;
  color: #343a40;
}

.w-full {
  width: 100%;
}
</style>
